export default __webpack_public_path__ + "static/media/cr-flag.8a1f8638.svg";